/**
 * 系统配置（systemConfiguration）模块英文映射（中文原文 → 英文 扁平映射）
 * 覆盖范围：src/views/systemConfiguration/ 下 流程定义列表、
 *          分类字典树形管理列表及其弹窗组件
 * 术语：系统配置=System Configuration，流程=Process，流程图=Flow Chart，
 *       分类字典=Category Dictionary，挂起=Suspend，激活=Activate，
 *       部署=Deploy
 */
export default {
  '上级': 'Parent',
  '分类': 'Category',
  '分类名称': 'Category Name',
  '分类名称已存在!': 'Category name already exists!',
  '分类字典管理页面': 'Category Dictionary Management Page',
  '删除': 'Delete',
  '删除失败': 'Deletion failed',
  '删除成功': 'Deleted successfully',
  '名称': 'Name',
  '备注': 'Remark',
  '序号': 'No.',
  '挂起': 'Suspend',
  '排序': 'Sort Order',
  '操作': 'Action',
  '新增': 'Add',
  '新增流程': 'Add Process',
  '新增流程定义': 'Add Process Definition',
  '无': 'None',
  '是否确认删除流程定义编号为"{deployId}"的数据项?': 'Are you sure to delete the process definition with deployment ID "{deployId}"?',
  '更多': 'More',
  '查询': 'Query',
  '流程名称': 'Process Name',
  '流程图': 'Flow Chart',
  '添加下级': 'Add Child',
  '添加子分类': 'Add Subcategory',
  '激活': 'Activate',
  '状态': 'Status',
  '确定': 'OK',
  '确定删除吗?': 'Are you sure you want to delete?',
  '确定挂起吗?': 'Are you sure to suspend?',
  '确定激活吗?': 'Are you sure to activate?',
  '编辑': 'Edit',
  '编辑流程图': 'Edit Flow Chart',
  '获取流程图失败！': 'Failed to get flow chart!',
  '警告': 'Warning',
  '取消': 'Cancel',
  '返回': 'Back',
  '部署人': 'Deployed By',
  '部署时间': 'Deployed At',
  '重置': 'Reset',
  '请输入名称': 'Please enter name',
  '请输入名称!': 'Please enter the name!',
  '请输入备注': 'Please enter remark',
  '请输入排序': 'Please enter sort order',
  '请输入排序!': 'Please enter sort order!',
  '请输入标准名称!': 'Please enter standard name!',
  '请输入标准编码!': 'Please enter standard code!',
  '请输入正确的排序!': 'Please enter a valid sort order!',
  '请输入流程名称查询': 'Enter process name to search',
  '请选择': 'Please select',
  '请选择上级!': 'Please select parent!',
  '请选择使用状态!': 'Select usage status',
  '请选择分类名称查询': 'Select category name to search',
}
